/** SpikeHandler, DeathZoneHandler, DeathTriggerHandler, GenericHazardHandler. */
import { GameBehaviour } from '../game.ts';
import { BodyType, type Collision2D, type SimCollider } from '../world.ts';
import { PrimaryWaysToDie, type Deathod } from '../unity.ts';
import { isRespawnable, PlayerController } from '../player.ts';
import { bool, num } from '../props.ts';

const SECONDARY = ['Nothing', 'Patroller', 'BluePlasma', 'Cannonball', 'SpikeyBall', 'String', 'StringPlayerDied', 'PlayerDisconnected', 'LastCheckpointPressed'];

export function deathodFrom(d: any, def: PrimaryWaysToDie): Deathod {
  if (!d || typeof d !== 'object') return { primary: def };
  return { primary: num(d.primary, def) as PrimaryWaysToDie, secondary: SECONDARY[num(d.secondary)] ?? 'Nothing' };
}

export class SpikeHandler extends GameBehaviour {
  static override checkpointable = false;
  override onTriggerEnter(other: SimCollider) {
    // GetComponent<IRespawnable>(): the first one only
    for (const r of other.go.behaviours) {
      if (!isRespawnable(r)) continue;
      r.beginDeath({ primary: PrimaryWaysToDie.Spikes });
      break;
    }
  }
}

export class DeathZoneHandler extends GameBehaviour {
  static override checkpointable = false;
  override start() {
    if (this.go.sprite) this.go.sprite.enabled = false;
    const c = this.go.colliders[0];
    if (c) c.setTrigger(true);
    if (this.go.body) this.go.body.type = BodyType.Static;
  }
  override onTriggerEnter(other: SimCollider) {
    for (const r of other.go.behaviours.slice()) if (isRespawnable(r)) r.beginDeath({ primary: PrimaryWaysToDie.DeathZone });
  }
}

export class DeathTriggerHandler extends GameBehaviour {
  static override checkpointable = false;
  deathod: Deathod = { primary: PrimaryWaysToDie.Spikes };
  onlyEffectPlayers = true;
  override awake() {
    this.deathod = deathodFrom(this.data.deathod, PrimaryWaysToDie.Spikes);
    this.onlyEffectPlayers = bool(this.data.onlyEffectPlayers, true);
  }
  override onTriggerEnter(other: SimCollider) {
    for (const r of other.go.behaviours.slice()) {
      if (!isRespawnable(r)) continue;
      if (this.onlyEffectPlayers && !other.go.getBehaviour(PlayerController)) return;
      r.beginDeath(this.deathod);
    }
  }
}

export class GenericHazardHandler extends GameBehaviour {
  static override checkpointable = false;
  deathod: Deathod = { primary: PrimaryWaysToDie.Spikes };
  override awake() {
    this.deathod = { primary: num(this.data.primary, 0) as PrimaryWaysToDie, secondary: SECONDARY[num(this.data.secondary)] ?? 'Nothing' };
  }
  override onTriggerEnter(other: SimCollider) {
    this.tryKill(other);
  }
  override onCollisionEnter(c: Collision2D) {
    this.tryKill(c.collider);
  }
  private tryKill(other: SimCollider) {
    for (const r of other.go.behaviours.slice()) if (isRespawnable(r)) r.beginDeath({ ...this.deathod });
  }
}
